export const initVideos = () => {
  const videos = document.querySelectorAll("[data-video]");

  if (!videos.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const wrapper = entry.target;
        const video = wrapper.querySelector("video");

        if (!video || video.dataset.loaded) return;

        video.querySelectorAll("source").forEach((source) => {
          if (source.dataset.src) {
            source.src = source.dataset.src;
          }
        });

        video.load();
        video.play().catch(() => {});

        video.dataset.loaded = "true";
        observer.unobserve(wrapper);
      });
    },
    {
      rootMargin: "200px",
      threshold: 0.25,
    },
  );

  videos.forEach((video) => observer.observe(video));
};
